import React, { useEffect } from "react";
import styled from "styled-components";
import { Alert, device, Slider_ } from "monica-alexandria";
import { useTranslation } from "react-i18next";

const CrmLeadWrapper = styled.div`
  .SliderWrapper {
    max-width: 80%;

    @media ${device.md} {
      max-width: 100%;
    }
  }

  .SliderContainer {
    padding: 0;
  }
`;

const CrmEditLeadGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(28rem, 1fr);
  height: 100%;
  margin-top: -2rem;
  padding-left: 4rem;

  @media ${device.md} {
    grid-template-columns: 1fr;
    padding-left: 0;
  }
`;

const CrmEditLeadDesktopHeader = styled.div`
  padding: 2rem 2rem 0 4rem;
`;

const CrmEditLeadSingle = styled.div`
  padding: 0 2rem 10rem 4rem;
`;

const CrmEditLeadLeft = styled.div`
  padding: 2rem 2rem 10rem 0;
  position: sticky;
  /* top: 2rem; */
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  &.split-details {
    border-right: 1px solid color-mix(in srgb, ${p => p.theme.color} 12%, transparent);
  }

  @media ${device.md} {
    padding: 2rem 2rem 2rem 2rem;
    border-bottom: 1px solid ${p => p.theme.low};
  }
`;

const CrmEditLeadRight = styled.div`
  background: ${p => p.theme.mid};
  min-width: 0;

  &.split-notes {
    padding-top: 2rem;
  }

  @media ${device.md} {
    padding: 2rem;
  }
`;

  export default function Lead_Editor_Layout({title, onSave, onCancel, activeTab = "details", notesOnRight = false, archivedLabel, headerActions, columnSelectContent, leftContent, notesContent, scheduleContent,}) {

    const {t} = useTranslation();

    const useIsMobile = () => {
      const [isMobile, setIsMobile] = React.useState(false);

      useEffect(() => {
        const media = window.matchMedia(device.md.replace("@media ", ""));
        const listener = () => setIsMobile(media.matches);
        listener();
        media.addEventListener("change", listener);
        return () => media.removeEventListener("change", listener);
    }, []);

  return isMobile;
};
 const isMobile = useIsMobile();
  return (
    <CrmLeadWrapper>
      <Slider_
        title={title}
        text={t("Done")}
        onClick={onSave}
        onClose={onCancel || onSave}
      >
        <Alert />
        {!isMobile && (
          <>
            <CrmEditLeadDesktopHeader>
              {archivedLabel}
              {headerActions}
            </CrmEditLeadDesktopHeader>

            {notesOnRight ? (
              <CrmEditLeadGrid>
                <CrmEditLeadLeft className="split-details">
                  {activeTab === "schedule" ? (
                    scheduleContent
                  ) : (
                    <>
                      {columnSelectContent}
                      {leftContent}
                    </>
                  )}
                </CrmEditLeadLeft>
                <CrmEditLeadRight className="split-notes">{notesContent}</CrmEditLeadRight>
              </CrmEditLeadGrid>
            ) : activeTab === "schedule" ? (
              <CrmEditLeadSingle>{scheduleContent}</CrmEditLeadSingle>
            ) : activeTab === "notes" ? (
              <CrmEditLeadSingle>
                <CrmEditLeadRight>{notesContent}</CrmEditLeadRight>
              </CrmEditLeadSingle>
            ) : (
              <CrmEditLeadSingle>
                {columnSelectContent}
                {leftContent}
              </CrmEditLeadSingle>
            )}
          </>
        )}

        {isMobile && (
          <>
            {activeTab === "notes" ? (
              <CrmEditLeadRight>
                {archivedLabel}
                {headerActions}
                {notesContent}
              </CrmEditLeadRight>
            ) : (
              <CrmEditLeadLeft>
                {archivedLabel}
                {headerActions}
                {activeTab === "details" ? <>{columnSelectContent}{leftContent}</> : scheduleContent}
              </CrmEditLeadLeft>
            )}
          </>
        )}
      </Slider_>
    </CrmLeadWrapper>
  );
}
